import { Languages, X } from 'lucide-react';
import { Button, ProgressBar } from '@hump/ui';
import { useTranslateStore } from '../../stores/translate';
import { useReaderStore } from '../../stores/reader';
import { isConfigured } from '../../lib/ai/config';

export function TranslateAllButton() {
  const { docId, blocks } = useReaderStore();
  const { translating, translatedCount, totalCount, translateAll, cancelTranslate, error } = useTranslateStore();
  const configured = isConfigured();

  const untranslatedCount = blocks.filter((b) => b.transStatus !== 'done' && b.type !== 'code' && b.original.trim()).length;
  if (!docId || untranslatedCount === 0) return null;

  return (
    <div className="flex items-center gap-3">
      {translating ? (
        <>
          <Button variant="secondary" size="sm" disabled>
            <Languages className="w-4 h-4 mr-1" />
            {translatedCount}/{totalCount}
          </Button>
          <ProgressBar value={totalCount > 0 ? (translatedCount / totalCount) * 100 : 0} className="w-24 h-1" />
          <Button variant="danger" size="sm" onClick={cancelTranslate}>
            <X className="w-3 h-3 mr-1" />
            取消
          </Button>
        </>
      ) : (
        <Button variant="secondary" size="sm" disabled={!configured} onClick={() => translateAll(docId, blocks)}>
          <Languages className="w-4 h-4 mr-1" />
          翻译全文 ({untranslatedCount})
        </Button>
      )}
      {error && <span className="text-error text-xs">{error}</span>}
    </div>
  );
}
